export const getCookieValue = (cookieName) => {
	let value = null;
	const relatedCookie = document.cookie.split('; ').find(row => row.startsWith(cookieName));
	if (relatedCookie) {
		value = relatedCookie.split('=')[1];
	}
	return value;
};


// WEBPACK FOOTER //
// ./src/utils/cookie.js